<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close close" (click)="close()">
    <i class="icon-close font-weight-bold"></i>
  </button>
</div>

<div class="modal-body">
  <!-- HTML PREVIEW -->
  <div *ngIf="channel === 'HTML' && apiResData?.htmlContent">
    <iframe
      [srcdoc]="apiResData.htmlContent"
      style="width: 100%; height: 80vh"
    ></iframe>
  </div>

  <!-- PDF PREVIEW -->
  <div *ngIf="channel === 'PDF' && pdfUrl">
    <iframe [src]="pdfUrl" width="100%" height="600" frameborder="0"> </iframe>
  </div>

  <!-- EMAIL / SMS / WHATSAPP -->
  <ng-container *ngIf="channel !== 'PDF'">
    <!-- EMAIL HEADER -->
    <div *ngIf="channel === 'EMAIL' && apiResData">
      <table class="table table-sm">
        <tr>
          <th>To</th>
          <td>{{ apiResData.to }}</td>
        </tr>
        <tr>
          <th>CC</th>
          <td>{{ apiResData.cc }}</td>
        </tr>
        <tr>
          <th>BCC</th>
          <td>{{ apiResData.bcc }}</td>
        </tr>
      </table>
    </div>
    <!-- CONTENT PREVIEW -->
    <div *ngIf="viewType !== 'SEND'">
      <div
        class="content-preview border p-2"
        [innerHTML]="apiResData?.body"
        *ngIf="channel === 'EMAIL'"
      ></div>

      <pre *ngIf="channel === 'SMS'">{{ apiResData?.body }}</pre>
      <pre *ngIf="channel === 'WHATSAPP'" class="whatsapp-preview"
        >{{ apiResData?.body }}
    </pre
      >
    </div>

    <!-- EDIT MODE -->
    <div [hidden]="viewType !== 'SEND'">
      <app-form-generator #basicForm [formData]="FORM_CONFIG" />

      <!-- <div
        class="border p-2 mt-2"
        contenteditable="true"
        (blur)="onBodyChange($event)"
        [innerHTML]="apiResData.body"
      ></div> -->

      <app-form-doc
        #docForm
        [mode]="'EDIT'"
        [config]="{ title: 'Attachments' }"
      />
    </div>
  </ng-container>

  <!-- LOADER -->
  <div *ngIf="loading" class="text-center mt-3">
    <i class="pi pi-spin pi-spinner"></i> Loading...
  </div>
</div>

<div class="modal-footer text-center">
  <button
    *ngIf="viewType === 'SEND'"
    class="btn btn-success"
    [disabled]="loading"
    (click)="send()"
  >
    <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
    {{ loading ? "sending..." : "Send" }}
  </button>

  <button class="btn btn-warning" (click)="close()">Close</button>
</div>
